import Box from "@mui/material/Box";
import React from "react";

interface FilterPanelProps {
  id: string;
  children?: React.ReactNode;
  activeFilterId: string;
}

export const FilterPanel = (props: FilterPanelProps) => {
  const { children, activeFilterId, id } = props;

  return (
    <Box
      id={`filter-panel-${id}`}
      role="tabpanel"
      hidden={activeFilterId !== id}
      width="100%"
    >
      <Box
        py={5}
        px={4}
        visibility={activeFilterId === id ? "visible" : "hidden"}
      >
        {children}
      </Box>
    </Box>
  );
};
